// src/components/IframeComponent.jsx
import React from 'react';

// Accept containerWidth prop AND children
function IframeComponent({ opentokUrl, isPortrait, containerHeight, containerWidth, children }) {
    const landscapeAspectRatio = 16 / 9;
    const portraitAspectRatio = 9 / 16; // Inverse for portrait

    let iframeWidth;
    let iframeHeight;

    // Ensure we have valid container dimensions > 0
    const validHeight = Math.max(1, containerHeight);
    const validWidth = Math.max(1, containerWidth);

    // --- Aspect ratio calculation logic ---
    if (isPortrait) {
        // Calculate dimensions based on portrait aspect ratio (9:16)
        const widthBasedOnHeight = validHeight * portraitAspectRatio;
        const heightBasedOnWidth = validWidth / portraitAspectRatio;

        // Fit within container: Choose the calculation that respects both width and height limits
        if (widthBasedOnHeight <= validWidth) {
            // Height is the limiting dimension
            iframeHeight = validHeight;
            iframeWidth = widthBasedOnHeight;
        } else {
            // Width is the limiting dimension
            iframeWidth = validWidth;
            iframeHeight = heightBasedOnWidth;
        }
    } else {
        // Calculate dimensions based on landscape aspect ratio (16:9)
        const widthBasedOnHeight = validHeight * landscapeAspectRatio;
        const heightBasedOnWidth = validWidth / landscapeAspectRatio;

        // Fit within container
        if (widthBasedOnHeight <= validWidth) {
            // Height is the limiting dimension
            iframeHeight = validHeight;
            iframeWidth = widthBasedOnHeight;
        } else {
            // Width is the limiting dimension
            iframeWidth = validWidth;
            iframeHeight = heightBasedOnWidth;
        }
    }

    // Final check for valid numbers
    iframeWidth = Math.max(1, iframeWidth || 1);
    iframeHeight = Math.max(1, iframeHeight || 1);
    // --- End of calculation logic ---


    return (
        // This div now establishes the positioning context for the buttons (children)
        // It's sized explicitly to match the calculated iframe dimensions.
        <div
            className="flex items-center justify-center overflow-hidden relative" // Added `relative`
            style={{
                width: `${iframeWidth}px`, // Set size explicitly to match iframe
                height: `${iframeHeight}px`, // Set size explicitly to match iframe
            }}
        >
            <iframe
                src={opentokUrl}
                title="Video Conference"
                scrolling="no"
                allow="camera; microphone; fullscreen"
                allowFullScreen
                style={{
                    width: '100%', // Fill the wrapper div
                    height: '100%', // Fill the wrapper div
                    border: 'none',
                    display: 'block',
                    objectFit: 'contain', // Ensures video content fits without cropping
                }}
            />
            {/* Render the children (buttons container) inside the relative parent */}
            {/* Absolute positioning within children will be relative to this div */}
            {children}
        </div>
    );
}

export default IframeComponent;
